import { post } from './http'
import global from '@/api/global'
var name = global.signature
var name1 = global.contractName
var name2 = global.orderName
var payName = global.payName
var stockName = global.stockName
var smpName = global.smpName

// 查询人员结构树
export const selectPersonnelTree = p => post(`/${name}/cFlowNode/selectPersonnelTree`, p)
// 新增流程
export const flowAdd = p => post(`/${name}/cFlow/add`, p)
// 流程列表
export const flowList = p => post(`/${name}/cFlow/flowList`, p)
// 流程列表新
export const flowListNew = p => post(`/${name}/cFlow/flowListNew`, p)
// 启用停用
export const isUse = p => post(`/${name}/cFlow/isUse`, p)
// 删除流程
export const cFlowDel = p => post(`/${name}/cFlow/delete`, p)
// 编辑流程跳转
export const updateDetail = p => post(`/${name}/cFlow/updateDetail`, p)
// 删除节点
export const CFNdel = p => post(`/${name}/cFlowNode/delete`, p)
// 删除节点上的人员（平）
export const cFlowNodeUserDel = p => post(`/${name}/cFlowNodeUser/delete`, p)
// 编辑流程跳转
export const updateCFlow = p => post(`/${name}/cFlow/updateCFlow`, p)
// 所在仓库列表
export const warehouseList = p => post(`/${name}/cFlow/warehouseList`, p)
// 查看签章日志
export const signatureLogList = p => post(`/${name}/signatureLog/list`, p)
// 合同管理
export const findContractBypList = p => post(`/${name1}/contract/findContractBypList`, p)// 列表
export const getContractPdfShow = p => post(`/${name1}/api/contractSignature/getContractPdfShow`, p) // 查看pdf
export const getbusinessNo = p => post(`/${name2}/way/getbusinessNo`, p) // 运单详情
export const getListWayByOrderNo = p => post(`/${name2}/api/getListWayByOrderNo`, p) // 订单详情
// 车队端-运费出入
export const sOrderList = p => post(`/${name2}/sOrder/list`, p) // 订单详情

// 用户钱包-提现管理
export const tWithdrawalInfoList = p => post(`/${payName}/tWithdrawalInfo/list`, p) // 主数据
export const tWithdrawalInfoUpdate = p => post(`/${payName}/tWithdrawalInfo/update`, p) // 确认提现
export const tWithdrawalInfoUpdateData = p => post(`/${payName}/tWithdrawalInfo/updateData`, p) // 修改
export const bPayDictionaryUploadFile = p => post(`/${payName}/bPayDictionary/uploadFile`, p) // 图片上传接口
// 充值管理
export const tRechargeInfoList = p => post(`/${payName}/tRechargeInfo/list`, p) // 充值管理-银行卡
export const listAllCustomer = p => post(`/${payName}/tAccountCustinfo/listAllCustomer`, p) // 充值管理-银行卡
export const tRechargeInfoAdd = p => post(`/${payName}/tRechargeInfo/add`, p) // 充值管理-银行卡-新增1
export const tRechargeInfoDelete = p => post(`/${payName}/tRechargeInfo/delete`, p) // 充值管理-银行卡-删除
export const tRechargeInfoUpdateStatus = p => post(`/${payName}/tRechargeInfo/updateStatus`, p) // 充值管理-银行卡-充值到账
export const tRechargeInfoUpdate = p => post(`/${payName}/tRechargeInfo/update`, p) // 充值管理-银行卡-修改
export const getPayDetailByPC = p => post(`/${payName}/tAccountCustinfo/getPayDetailByPC`, p) // 获取登陆信息
// 提现申请-批量确认提现
export const updateForList = p => post(`/${payName}/tWithdrawalInfo/updateForList`, p) // 提现申请-确认提现
// 提现记录-列表
export const recordList = p => post(`/${payName}/tBatchWithdrawal/list`, p) // 提现记录-列表
// 提现记录-修改
export const updateDataForList = p => post(`/${payName}/tWithdrawalInfo/updateDataForList`, p)
// 控货一级二级下拉(梁)
export const customerList = p => post(`/${name}/t/goods/control/master/customerList`, p)
// 控货一级二级客户控货配置列表(梁)
export const getMasterAndSummaryList = p => post(`/${name}/t/goods/control/master/getMasterAndSummaryList`, p)
// 控货明细列表（贾）
export const SVCRlist = p => post(`/${name}/sVirtualControlRecord/list`, p)
// 控货指令列表（贾）
export const controlList = p => post(`/${name}/sVirtualControl/controlList`, p)
// 控货补单（贾）
export const SVCRupdate = p => post(`/${name}/sVirtualControlRecord/update`, p)
// 控货补单（贾）
export const SVCRadd = p => post(`/${name}/sVirtualControlRecord/add`, p)
// 控货指令统计（贾）
export const controlSum = p => post(`/${name}/sVirtualControlRecord/controlSum`, p)
// 控货指令统计（贾）
export const openCloseControl = p => post(`/${name}/sVirtualControlRecord/openCloseControl`, p)
// -------------控货客户配置-----------------
// 新增控货客户配置
export const addTGoodsControlMaster = p => post(`/${name}/t/goods/control/master/add`, p)
// 控货客户配置列表
export const tGoodsControlMasterList = p => post(`/${name}/t/goods/control/master/list`, p)
// 查看客户配置
export const viewGoodsControl = p => post(`/${name}/t/goods/control/master/view/${p}`)
// 删除客户配置
export const removeGoodsControl = p => post(`/${name}/t/goods/control/master/remove/${p}`)
// 山西美锦-删除
export const removeMasterForWMS = p => post(`/${name}/t/goods/control/master/removeMasterForWMS/${p}`)

// OMS货主端
// 签章管理-验证码
export const signatureApplySmsCheck = p => post(`/${name}/signatureApply/smsCheck`, p)
// 签章管理-申请签章
export const signatureApplyAdd = p => post(`/${name}/signatureApply/add`, p)
// 签章管理-查看
export const signatureApplyDetail = p => post(`/${name}/signatureApply/detail`, p)
// 签章管理-列表  平台用章管理-签章数量
export const signatureApplyList = p => post(`/${name}/signatureApply/list`, p)
// 签章管理-删除
export const signatureApplyDelete = p => post(`/${name}/signatureApply/delete`, p)
// 用章记录(平台/货主端)
export const signatureRecordList = p => post(`/${name}/signatureRecord/list`, p)
// 查看提货/转货函
export const sBillgetFileUrlBYBusinessNo = p => post(`/${stockName}/sBill/getFileUrlBYBusinessNo`, p)
// 平台-用章管理列表
export const signatureApplyPtList = p => post(`/${name}/signatureApply/pingtaiList`, p)

// OCR识别
// 标签管理列表
export const cOcrModelLabelList = p => post(`/${name}/cOcrModelLabel/list`, p)
// 标签添加
export const cOcrModelLabelAdd = p => post(`/${name}/cOcrModelLabel/add`, p)
// 标签删除
export const cOcrModelLabelDelete = p => post(`/${name}/cOcrModelLabel/delete`, p)
// 解析方法列表
export const cOcrModelMethodList = p => post(`/${name}/cOcrModelMethod/list`, p)
// 添加解析方法
export const cOcrModelMethodAdd = p => post(`/${name}/cOcrModelMethod/add`, p)
// 删除解析方法
export const cOcrModelMethodDelete = p => post(`/${name}/cOcrModelMethod/delete`, p)
// 模板管理列表
export const cOcrModelList = p => post(`/${name}/cOcrModel/list`, p)
// 添加模板
export const cOcrModelAdd = p => post(`/${name}/cOcrModel/add`, p)
// 删除模板
export const cOcrModelDelete = p => post(`/${name}/cOcrModel/delete`, p)
// 修改模板
export const cOcrModelUpdate = p => post(`/${name}/cOcrModel/update`, p)
// 添加模板 解析方法
export const methodList = p => post(`/${name}/cOcrModelMethod/methodList`, p)
// 添加模板 关联标签
export const labelList = p => post(`/${name}/cOcrModelLabel/labelList`, p)
// 示例图片
// export const checkExampleImage = p => post(`/${name}/cOcrModel/checkExampleImage`, p)
// 修改调取
export const cOcrModelDetail = p => post(`/${name}/cOcrModel/detail`, p)
// 控货记录
export const getAllControlRecord = p => post(`/${name}/sVirtualControlRecord/getAllControlRecord`, p)
// 支出结算-推送T+
export const getDicFromTms = p => post(`/${payName}/api/getDicFromTms`, p) // #推送哪个T+系统下拉框查询接口
// 推送T+系统确定 - 支出结算
export const pushTPlusToTmsPay = p => post(`/${payName}/downstreamSettlement/pushTPlusToTmsPay`, p)
// 推送T+系统确定 - 收入结算
export const pushTPlusToTmsCollection = p => post(`/${payName}/upstreamSettlement/pushTPlusToTmsCollection`, p)
// 平台账户中心-提现管理-上传回单  平
export const updateDrawalVoucher = p => post(`/${payName}/tWithdrawalInfo/updateDrawalVoucher`, p)
// 控货指令列表（中远）
export const controlListZy = p => post(`/${name}/sVirtualControl/controlListZy`, p)
// ocr识别身份证
export const ocrIdentification = p => post(`/${name}//api/ocrIdentification`, p)
// 资金计划
// 查询现金流量项目列表
export const findCashFlowItemList = p => post(`${smpName}/cashFlowItem/findCashFlowItemList`, p)
// 现金流量项目新增
export const saveCashFlowItemList = p => post(`${smpName}/cashFlowItem/saveCashFlowItemList`, p)
// 修改现金流量项
export const updateCashFlowItemList = p => post(`${smpName}/cashFlowItem/updateCashFlowItemList`, p)
// 删除现金流量项目
export const deleteCashFlowItemList = p => post(`${smpName}/cashFlowItem/deleteCashFlowItemList`, p)
// 查询资金计划周期列表
export const findFundPlanCycleList = p => post(`${smpName}/fundPlanCycleMaster/findFundPlanCycleList`, p)
// 添加资金计划周期
export const saveFundPlanCycle = p => post(`${smpName}/fundPlanCycleMaster/saveFundPlanCycle`, p)
// 添加资金计划周期周数据
export const saveFundPlanCycleWeek = p => post(`${smpName}/fundPlanCycleMaster/saveFundPlanCycleWeek`, p)
// 修改资金计划周期
export const updateFundPlanCycle = p => post(`${smpName}/fundPlanCycleMaster/updateFundPlanCycle`, p)
// 删除资金计划周期
export const deleteFundPlanCycle = p => post(`${smpName}/fundPlanCycleMaster/deleteFundPlanCycle`, p)
// 查询月资金计划列表列表
export const masterList = p => post(`${smpName}/monthlyFundPlanMaster/masterList`, p)
// 新增月资金计划主表
export const addMonthlyFundPlanMaster = p => post(`${smpName}/monthlyFundPlanMaster/addMonthlyFundPlanMaster`, p)
// 删除月资金计划主表
export const delMonthlyFundPlanMaster = p => post(`${smpName}/monthlyFundPlanMaster/delMonthlyFundPlanMaster`, p)
// 查询月资金计划详情列表（详情、修改、审核回显）
export const detailList = p => post(`${smpName}/monthlyFundPlanMaster/detailList`, p)
// 保存月资金计划详情（新增或修改月资金计划子表）
export const saveMonthlyFundPlanDetail = p => post(`${smpName}/monthlyFundPlanMaster/saveMonthlyFundPlanDetail`, p)
// 月资金计划提交审核
export const monthlySubmitForReview = p => post(`${smpName}/monthlyFundPlanMaster/monthlySubmitForReview`, p)
// 删除月资金计划详情（删除月资金计划子表）
export const delMonthlyFundPlanDetail = p => post(`${smpName}/monthlyFundPlanMaster/delMonthlyFundPlanDetail`, p)
// 查询周资金计划列表列表
export const weekMasterList = p => post(`${smpName}/weeklyFundPlanMaster/masterList`, p)
// 周资金计划提交审核
export const weeklySubmitForReview = p => post(`${smpName}/weeklyFundPlanMaster/weeklySubmitForReview`, p)
// 周资金计划审核通过
export const weeklyApprove = p => post(`${smpName}/weeklyFundPlanMaster/weeklyApprove`, p)
// 周资金计划审核驳回
export const weeklyNotApprove = p => post(`${smpName}/weeklyFundPlanMaster/weeklyNotApprove`, p)
// 查询周资金计划详情列表（详情、修改、审核回显）
export const weekDetailList = p => post(`${smpName}/weeklyFundPlanMaster/detailList`, p)
// 月资金计划审核通过
export const monthlyApprove = p => post(`${smpName}/monthlyFundPlanMaster/monthlyApprove`, p)
// 月资金计划审核驳回
export const monthlyNotApprove = p => post(`${smpName}/monthlyFundPlanMaster/monthlyNotApprove`, p)
// 保存周资金计划详情——【编写修改&待编写、待提交、审核驳回】（新增或修改周资金计划子表）
export const saveWeeklyFundPlanDetail = p => post(`${smpName}/weeklyFundPlanMaster/saveWeeklyFundPlanDetail`, p)
// 保存周资金计划详情——【实际收支&审核通过】（新增或修改周资金计划子表）
export const saveWeeklyFundPlanDetailForSjsz = p => post(`${smpName}/weeklyFundPlanMaster/saveWeeklyFundPlanDetailForSjsz`, p)
// 删除周资金计划详情（删除周资金计划子表）
export const delWeeklyFundPlanDetail = p => post(`${smpName}/weeklyFundPlanMaster/delWeeklyFundPlanDetail`, p)
// 保存周资金计划详情——调整【审核通过】（新增或修改周资金计划子表）
export const saveWeeklyFundPlanDetailForTz = p => post(`${smpName}/weeklyFundPlanMaster/saveWeeklyFundPlanDetailForTz`, p)
// 删除周资金计划详情——调整【审核通过】（新增或修改周资金计划子表）
export const delWeeklyFundPlanDetailForTz = p => post(`${smpName}/weeklyFundPlanMaster/delWeeklyFundPlanDetailForTz`, p)
// 查询计划调整记录表
export const findPlanAdjustRecordList = p => post(`${smpName}/planAdjustRecord/findPlanAdjustRecordList`, p)
// 现金流量项目列表
export const findCashFlowItemLists = p => post(`${smpName}/cashFlowItem/findCashFlowItemLists`, p)
// 保存周资金计划详情——【编写修改&待编写、待提交、审核驳回】-校验
export const saveWeeklyDetailCheck = p => post(`${smpName}/weeklyFundPlanMaster/saveWeeklyDetailCheck`, p)
// 查询今天所属的资金计划周期周数据
export const findFundPlanCycleForToday = p => post(`${smpName}/fundPlanCycleMaster/findFundPlanCycleForToday`, p)
// 月资金计划汇总表
export const monthlyFundPlanReportForInOut = p => post(`${smpName}/tReportDataView/monthlyFundPlanReportForInOut`, p)
// 月资金计划汇总表
export const weeklyFundPlanReportForInOut = p => post(`${smpName}/tReportDataView/weeklyFundPlanReportForInOut`, p)
// 资金计划周期-修改月提交计划日期
export const updateMonthSubmitPlan = p => post(`${smpName}/fundPlanCycleMaster/updateMonthSubmitPlan`, p)
// 现金流量-收支明细列表
export const tFlowIncomeExpenditureDetailList = p => post(`${smpName}/tFlowIncomeExpenditureDetail/list`, p)
// 现金流量-收支明细导入
export const tFlowIncomeExpenditureDetailImport = p => post(`${smpName}/tFlowIncomeExpenditureDetail/import`, p)
// 现金流量-项目现金流量统计
export const statisticDepartment = p => post(`${smpName}/tFlowIncomeExpenditureDetail/statistic/department`, p)
// 现金流量-各系现金流量统计
export const statisticFaction = p => post(`${smpName}/tFlowIncomeExpenditureDetail/statistic/faction`, p)
// 现金流量-查询字典
export const tFlowIncomeExpenditureDetailOptions = p => post(`${smpName}/tFlowIncomeExpenditureDetail/options`, p)
// 月资金计划汇总&周资金计划汇总查询可用总额
export const getAmountList = p => post(`${smpName}/fundPlanCycleAmount/getAmountList`, p)
// 新增可用总额
export const saveFundPlanCycleAmount = p => post(`${smpName}/fundPlanCycleAmount/saveFundPlanCycleAmount`, p)
// 修改可用总额
export const updateFundPlanCycleAmount = p => post(`${smpName}/fundPlanCycleAmount/updateFundPlanCycleAmount`, p)
// 收支明细-新增
export const tFlowIncomeExpenditureDetailAdd = p => post(`${smpName}/tFlowIncomeExpenditureDetail/add`, p)
// 收支明细-修改
export const tFlowIncomeExpenditureDetailUpdate = p => post(`${smpName}/tFlowIncomeExpenditureDetail/update`, p)
// 收支明细-删除
export const tFlowIncomeExpenditureDetailDelete = p => post(`${smpName}/tFlowIncomeExpenditureDetail/batchDelete`, p)
// 部门现金流量-详情
export const queryDetails = p => post(`${smpName}/tFlowIncomeExpenditureDetail/queryDetailsByDepartmentAndItem`, p)
// 月资金计划审核撤销
export const monthlyReviewRevoke = p => post(`${smpName}/monthlyFundPlanMaster/monthlyReviewRevoke`, p)
// 月资金计划删除
export const delMonthlyFundPlan = p => post(`${smpName}/monthlyFundPlanMaster/delMonthlyFundPlan`, p)
// 月资金计划审核撤销
export const weeklyReviewRevoke = p => post(`${smpName}/weeklyFundPlanMaster/weeklyReviewRevoke`, p)
// 月资金计划导入
export const imporMonthlyFundPlanDetail = p => post(`${smpName}/monthlyFundPlanMaster/imporMonthlyFundPlanDetail`, p)

// merged missing exports from zw56-platform-web
export const getContractPdfForBusinessNo = p => post(`/${name}/api/common/contractSignature/getContractPdfForBusinessNo`, p) // 查看pdf

// -------------项目管理（projCostMgt）-----------------
// 通用数据字典下拉框列表
export const listByGroupNoCommon = p => post(smpName + '/smpDictionary/listByGroupNoCommon', p)
// 项目管理列表
export const projectInfoList = p => post(`${smpName}/projectInfo/projectInfoList`, p)
// 导出项目管理列表
export const exportProjectInfo = p => post(`${smpName}/projectInfo/exportProjectInfo`, p)
// 新增项目
export const addProjectInfo = p => post(`${smpName}/projectInfo/addProjectInfo`, p)
// 修改项目
export const updateProjectInfo = p => post(`${smpName}/projectInfo/updateProjectInfo`, p)
// 变更状态回显当前状态开始时间
export const getProjectStatus = p => post(`${smpName}/projectInfo/getProjectStatus`, p)
// 变更项目状态
export const updateProjectStatus = p => post(`${smpName}/projectInfo/updateProjectStatus`, p)
// 删除项目
export const delProjectInfo = p => post(`${smpName}/projectInfo/delProjectInfo`, p)
// 项目详情（含状态变更记录）
export const getProjectInfo = p => post(`${smpName}/projectInfo/getProjectInfo`, p)

// -------------日报管理（projCostMgt）-----------------
// 保存日报（新增/修改共用）
export const dailyWorkAdd = p => post(`${smpName}/dailyWork/addDailyWork`, p)
// 删除日报
export const dailyWorkDel = p => post(`${smpName}/dailyWork/delDailyWork`, p)
// 查询详情列表（详情、修改回显）
export const dailyWorkDetail = p => post(`${smpName}/dailyWork/detailList`, p)
// 查询日报管理列表
export const dailyWorkList = p => post(`${smpName}/dailyWork/dailyWorkList`, p)

// -------------融资授信-----------------
// 银行列表
export const findBankList = p => post(`${smpName}/bank/findBankList`, p)
// 银行新增
export const addBankInfo = p => post(`${smpName}/bank/addBankInfo`, p)
// 银行修改
export const updateBankInfo = p => post(`${smpName}/bank/updateBankInfo`, p)
// 银行删除
export const deleteBankInfo = p => post(`${smpName}/bank/deleteBankInfo`, p)
// 人员配置列表
export const companySettingList = p => post(`${smpName}/companySetting/list`, p)
// 修改公司配置
export const updateUserCompanySetting = p => post(`${smpName}/companySetting/updateUserCompanySetting`, p)
// 修改公司配置
export const deleteUserCompanySetting = p => post(`${smpName}/companySetting/deleteUserCompanySetting`, p)
// 公司下拉（当前用户可访问公司）
export const getUserCompanyDropDown = p => post(`${smpName}/companySetting/getUserCompanyDropDown`, p)
// 字段管理
export const getDictionaryMasterList = p => post(`${smpName}/dictionary/getDictionaryMasterList`, p)// 列表查询
export const getDictionaryDetailList = p => post(`${smpName}/dictionary/getDictionaryDetailList`, p)// 字典管理-维护列表查询
export const addOrUpDictionaryDetail = p => post(`${smpName}/dictionary/addOrUpDictionaryDetail`, p)// 字典管理-字典维护新增或修改或删除
// 预警设置
export const getWarningReminderSet = p => post(`${smpName}/dictionaryDetail/getWarningReminderSet`, p)// 预警查询
export const updateWarningReminderSet = p => post(`${smpName}/dictionaryDetail/updateWarningReminderSet`, p)// 修改授信贷款预警提醒设置

// 银行授信 - 列表查询（条件：companyName / bankName / securityUser / legalPerson + pageNo / pageSize）
export const findCreditInfoList = p => post(`${smpName}/credit/findCreditInfoList`, p)
// 银行授信 - 新增  参数：{ files: 文件数组, params: FinCreditInfo 实体 }
export const addCreditInfo = p => post(`${smpName}/credit/addCreditInfo`, p)
// 银行授信 - 删除  参数：{ id: 主键 }
export const deleteCreditInfo = p => post(`${smpName}/credit/deleteCreditInfo`, p)
// 银行授信 - 修改  参数：{ files: 新增附件, deleteFileIds: 删除附件ids数组, params: FinCreditInfo 实体 }
export const updateCreditInfo = p => post(`${smpName}/credit/updateCreditInfo`, p)
// 银行授信 - 详情  参数：{ id }  返回 { finCreditInfo, files, loanAmount, unUseCreditAmount }
export const getCreditInfo = p => post(`${smpName}/credit/getCreditInfo`, p)
// 银行授信 - 导出  参数同列表查询条件
export const exportCreditInfo = p => post(`${smpName}/credit/exportCreditInfo`, p)

// -------------融资授信-汇总报表-----------------
// 授信公司汇总报表  参数：{ yearDate: 年份 }
export const findCompanySummaryReport = p => post(`${smpName}/credit/findCompanySummaryReport`, p)
// 授信金额汇总  参数：{ ids: 取授信公司汇总报表返回值ids }
export const findCreditReport = p => post(`${smpName}/credit/findCreditReport`, p)
// 贷款金额汇总  参数：{ ids: 取授信公司汇总报表返回值ids }
export const findLoanReport = p => post(`${smpName}/credit/findLoanReport`, p)
// 授信公司汇总报表导出  参数：{ yearDate: 年份 }
export const exportCompanySummaryReport = p => post(`${smpName}/credit/exportCompanySummaryReport`, p)
// 授信银行汇总报表  参数：{ yearDate: 年份 }
export const findBankSummaryReport = p => post(`${smpName}/credit/findBankSummaryReport`, p)
// 授信银行汇总报表导出  参数：{ yearDate: 年份 }
export const exportBankSummaryReport = p => post(`${smpName}/credit/exportBankSummaryReport`, p)
// 投融资情况报表  参数：列表查询条件（年份/公司等）
export const findInvestmenFinancSituationReport = p => post(`${smpName}/credit/findInvestmenFinancSituationReport`, p)
// 投融资情况报表导出  参数同查询条件
export const exportInvestmenSituationReport = p => post(`${smpName}/credit/exportInvestmenSituationReport`, p)

// -------------融资授信-贷款管理-----------------
// 贷款新增  参数：{ creditId, putDate, backDate, loanAmount, loanRate, loanLife, backInterestDate, loanPlan }
export const loanInfoAdd = p => post(`${smpName}/loanInfo/add`, p)
// 删除贷款  参数：{ id }
export const loanInfoDelete = p => post(`${smpName}/loanInfo/delete`, p)
// 更新贷款
export const loanInfoUpdate = p => post(`${smpName}/loanInfo/update`, p)
// 贷款列表查询  参数：{ companyName, bankName, securityUser, legalPerson }
export const loanInfoList = p => post(`${smpName}/loanInfo/list`, p)
// 查询贷款详情  参数：{ id }  返回：{ finLoanInfo 贷款信息, finCreditInfo 授信信息, files 文件信息 }
export const loanInfoDetail = p => post(`${smpName}/loanInfo/detail`, p)
// 贷款管理统计查询  请求参数：列表查询参数
//     twoYearTotalRate 两年期及以上贷款占比
export const loanInfoListTotal = p => post(`${smpName}/loanInfo/listTotal`, p)
// 查询平均贷款利率  请求参数：{ year }  // { year: '2026' }
export const loanInfoAvgData = p => post(`${smpName}/loanInfo/avgData`, p)

// -------------融资授信-贷款利率记录(loanRateRecord)-----------------
// 查询贷款利率记录列表  请求参数：列表查询参数（如 loanId 等）
export const loanRateRecordList = p => post(`${smpName}/loanRateRecord/list`, p)

// -------------融资授信-贷款本金(loanBack)-----------------
// 查询贷款本金明细列表  参数：{ creditId, loanId }
export const findLoanBackList = p => post(`${smpName}/loanBack/findLoanBackList`, p)
// 还款  参数：参考实体（FinLoanBack 相关字段）
export const loanBackRepayment = p => post(`${smpName}/loanBack/repayment`, p)
// 撤销还款  参数：{ creditId, loanId, id }
export const loanBackRepaymentRevoke = p => post(`${smpName}/loanBack/repaymentRevoke`, p)

// -------------融资授信-贷款利息(loanInterest)-----------------
// 查询贷款利息明细列表  参数：{ creditId, loanId }
export const finLoanInterestList = p => post(`${smpName}/loanInterest/finLoanInterestList`, p)
// 贷款利息调整  参数：{ id, actualInterestAmount 实际扣款金额, actualInterestDate Date型 实际扣款日期 }
export const interestAdjustment = p => post(`${smpName}/loanInterest/interestAdjustment`, p)
